import { render, staticRenderFns } from "./LogDashboardActivity.vue?vue&type=template&id=b8183056&scoped=true&"
import script from "./LogDashboardActivity.vue?vue&type=script&lang=js&"
export * from "./LogDashboardActivity.vue?vue&type=script&lang=js&"
import style0 from "./LogDashboardActivity.vue?vue&type=style&index=0&id=b8183056&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8183056",
  null
  
)

export default component.exports